export default __webpack_public_path__ + "media/color/gas-162c83f4.svg";